import { useCallback, useMemo } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import enTranslations from "../locales/en.json";
import zhTranslations from "../locales/zh.json";
import zhTWTranslations from "../locales/zh-TW.json";
import koTranslations from "../locales/ko.json";
import viTranslations from "../locales/vi.json";
import hiTranslations from "../locales/hi.json";
import idTranslations from "../locales/id.json";
import taTranslations from "../locales/ta.json";
import jaTranslations from "../locales/ja.json";
import ruTranslations from "../locales/ru.json";

const translations = {
    en: enTranslations,
    zh: zhTranslations,
    "zh-TW": zhTWTranslations,
    ko: koTranslations,
    vi: viTranslations,
    hi: hiTranslations,
    id: idTranslations,
    ta: taTranslations,
    ja: jaTranslations,
    ru: ruTranslations,
};

export const useTranslation = () => {
    const { language } = useLanguage();

    const t = useCallback((key, variables = {}) => {
        const keys = key.split(".");
        let value = translations[language];

        for (const k of keys) {
            if (value && typeof value === "object") {
                value = value[k];
            } else {
                return key; // Return key if translation not found
            }
        }

        let result = value || key;

        // Replace variables in the string
        if (variables && typeof variables === "object") {
            Object.keys(variables).forEach((variable) => {
                const placeholder = `{${variable}}`;
                result = result.replace(
                    new RegExp(placeholder, "g"),
                    variables[variable]
                );
            });
        }

        return result;
    }, [language]);

    return useMemo(() => ({ t, language }), [t, language]);
};
